import React from 'react';
import { Box, Typography } from '@mui/material';

// Section heading used on the Dashboard (blue accent bar + title, optional action on the right)
const SectionTitle = ({ children, action }) => (
  <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
    <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary', display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ width: 4, height: 24, background: 'linear-gradient(45deg, #1976d2, #1565c0)', borderRadius: 2 }} />
      {children}
    </Typography>
    {action}
  </Box>
);

export const dashboardCardSx = {
  bgcolor: 'background.paper',
  border: '1px solid rgba(255, 255, 255, 0.8)',
  borderRadius: 3,
  boxShadow: 'var(--fx-card-shadow)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: 'var(--fx-card-shadow-hover)',
    transform: 'translateY(-2px)',
  },
};

export const CardHeading = ({ children, color }) => (
  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'text.primary', display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box sx={{ width: 3, height: 18, background: color, borderRadius: 1 }} />
    {children}
  </Typography>
);

export default SectionTitle;
